import { TEST_MANAGEMENT_TESTS } from '@elementary/common-ui/constants/queryKeys';
import useGraphqlQuery from '@elementary/common-ui/hooks/useGraphqlQuery';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import { getTestManagementTestsQuery } from 'shared/services/api';
import { TestManagementGqlTestsResponse } from 'shared/types';
import { resolveDestinationsQueryKey } from './destinationsQueryKey';

type Props<T> = {
  select?: (data: TestManagementGqlTestsResponse) => T;
  includeAlertDestinations?: boolean;
  enabled?: boolean;
  onError?: () => void;
};

const useTestManagementTests = <T = TestManagementGqlTestsResponse>({
  select,
  includeAlertDestinations = false,
  enabled = true,
  onError,
}: Props<T> = {}) => {
  const selectedEnvId = useSelectedEnv();

  const queryKey = resolveDestinationsQueryKey(
    [TEST_MANAGEMENT_TESTS, selectedEnvId],
    includeAlertDestinations,
  );

  return useGraphqlQuery<T>({
    query: getTestManagementTestsQuery,
    variables: { includeAlertDestinations },
    queryKey,
    enabled,
    onError,
    select,
  });
};

export default useTestManagementTests;
